// src/components/ErrorBoundary.tsx
import { Component, ErrorInfo, ReactNode } from 'react';
import { Alert, Button } from 'react-bootstrap';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null
    };

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Uncaught error:', error, errorInfo);
    }

    public render() {
        if (this.state.hasError) {
            return (
                <Alert variant="danger" className="m-3">
                    <Alert.Heading>Something went wrong</Alert.Heading>
                    <p>
                        {this.state.error?.message || 'An unexpected error occurred'}
                    </p>
                    <div className="d-flex justify-content-end">
                        <Button
                            variant="outline-danger"
                            onClick={() => {
                                this.setState({ hasError: false });
                                window.location.reload();
                            }}
                        >
                            Try again
                        </Button>
                    </div>
                </Alert>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;